import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Soundbar = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M.334 1.982h15.333V14.65H.334V1.982ZM15 2.65H1v11.333h14V2.649Z" />
      <path d="M6 4.648a3.667 3.667 0 1 1 0 7.334 3.667 3.667 0 0 1 0-7.334Zm0 6.667a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM12.001 11.982a.333.333 0 0 1-.333-.334V7.982a.333.333 0 1 1 .667 0v3.666a.333.333 0 0 1-.334.334ZM12.001 6.648a.333.333 0 0 1-.333-.333V4.982a.333.333 0 1 1 .667 0v1.333a.333.333 0 0 1-.334.333Z" />
      <path d="M13.334 6.65h-2.667a.333.333 0 1 1 0-.668h2.667a.333.333 0 1 1 0 .667ZM6 7.316a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM6 8.65a.333.333 0 1 0 0-.667.333.333 0 0 0 0 .667Z" />
    </svg>
  );
};

Soundbar.category = 'product-category';

Soundbar.displayName = 'Soundbar';
